// % che resta all'agenzia su Provvigione e FEE broker, secondo le etichette del modulo Broker:
// "FEE agenzia" = agency_share_percent, "Provvigione agenzia" = fee_agency_share_percent (vuoto → usa l'altro).
// Stessa priorità del backend: override link → % broker → link agency_only → retrocessione broker → 100%.
export const brokerSplitPcts = (broker, link) => {
  const all = (v) => ({ prov: v, fee: v });
  if (!broker) return all(100);
  if (link?.broker_commission_share_percent != null) return all(Math.max(0, 100 - (parseFloat(link.broker_commission_share_percent) || 0)));
  const A = broker.agency_share_percent;
  const F = broker.fee_agency_share_percent;
  if (A != null || F != null) {
    return { prov: parseFloat(F ?? A) || 0, fee: parseFloat(A ?? F) || 0 };
  }
  if (link?.broker_commission_share_split === "agency_only") return all(100);
  if (broker.broker_commission_share_percent != null) return all(Math.max(0, 100 - (parseFloat(broker.broker_commission_share_percent) || 0)));
  return all(100);
};
